// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import Form from '@core/forms/base';
import { ORDER_FIELDS } from '@shared/constants/order';

export default class OrderForm extends Form {
  setup() {
    return {
      fields: [
        {
          name: ORDER_FIELDS.orderName,
          type: 'text',
          rules: 'required',
        },
        {
          name: ORDER_FIELDS.orderNumber,
          type: 'text',
          rules: 'required'
        },
        {
          name: ORDER_FIELDS.type,
          type: 'text',
          rules: 'required'
        },
        {
          name: ORDER_FIELDS.customerId,
          type: 'text',
          rules: 'required'
        },
        {
          name: ORDER_FIELDS.dueDate,
          type: 'text',
          rules: 'required'
        },
        {
          name: ORDER_FIELDS.expectedDueDate,
          type: 'text',
        },
        {
          name: ORDER_FIELDS.actualDueDate,
          type: 'text',
        },
        {
          name: ORDER_FIELDS.notes,
          type: 'text',
          rules: 'max:500',
        },
        {
          name: ORDER_FIELDS.isBlocked,
          value: false,
        },
      ],
    };
  }
}
